export default function accordionInit() {
  console.log("accordioninit");
  jQuery(".sec-08__item dd").hide();
  jQuery(".sec-08__item dt").on("click", function () {
    jQuery(this).toggleClass('is-active');
    jQuery(this).next().slideToggle();
  });
}